import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthSession, SupabaseClient, createClient } from '@supabase/supabase-js'
import { AppContext } from './app-context.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';




@Injectable({
  providedIn: 'root',
})
export class SupabaseService {



  public supabase!: SupabaseClient
  _session: AuthSession | null = null

  constructor(public appContext: AppContext, private httpClient: HttpClient) {
    this.connectSuperbase();
  }

  connectSuperbase() {
    var supabaseCreds = environment.supabaseCreds.filter((supabaseCred: any)=> supabaseCred.accountId === this.appContext.siteAccountId)[0];
    if(supabaseCreds.supabaseProjectUrl && supabaseCreds.supabaseKey)
      this.supabase = createClient(supabaseCreds.supabaseProjectUrl, supabaseCreds.supabaseKey);
  }
  
  getPasswordResetLink(email: string): Observable<any>{
    return this.httpClient.get(`api/supabase/resetpassword?email=${email}`, { observe: 'response' });
  }

  updatePassword(token: string, updatedPassword: string){
    return this.httpClient.put(`api/supabase/updatepassword`, {token: token, updatedPassword: updatedPassword}, { observe: 'response' });
  }
}
